"use client"

import { GoogleTagManager } from "@src/components/GoogleTagManager"
import Helpscout from "@src/components/Helpscout"
import { SafeGoogleAnalytics } from "@src/components/SafeGoogleAnalytics"
import { GA4_MEASUREMENT_ID, GTM_ID } from "@src/utils/analyticsIds"
import { HELPSCOUT_BEACON_ID } from "@src/utils/environment"
import { isOnSensitiveRoute } from "@src/utils/sensitiveRoutes"
import { usePathname } from "next/navigation"

export function ThirdPartyScripts() {
  const pathname = usePathname()
  const suppress = isOnSensitiveRoute(pathname)

  return (
    <>
      <GoogleTagManager gtmId={GTM_ID} suppress={suppress} />
      <SafeGoogleAnalytics gaId={GA4_MEASUREMENT_ID} suppress={suppress} />
      {HELPSCOUT_BEACON_ID && <Helpscout suppress={suppress} />}
    </>
  )
}
